import { TabContainer } from "../shared.styles";

export default TabContainer;
